import _ from 'lodash';
import { connect } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { knowledgeSelectItem } from '../../../store/actions/knowledgeViewer.actions';
import { updateKnowledgeItemsOrder } from 'shared/store/actions/knowledge.items.actions';
import { KnowledgeBinderComponent } from './knowledge-binder.component';
import { getCategoryById } from 'shared/store/selectors/knowledge.selector';
import { useCategoryItems } from 'shared/hooks/knowledge-items.hooks';
import { INTERNAL_ROUTING } from 'shared/constants';

const mapStateToProps = ({ knowledge, application, lang }, ownProps) => {
  const { id } = ownProps;

  // The category's own `knowledgeItems` are bare entries; the rows come from the hook.
  const category = _.omit(id ? getCategoryById(knowledge, { id }) : {}, 'knowledgeItems');

  return {
    id,
    ...category,
    adminMode: application.adminMode && !category?.options?.externalSyncProvider,
    showExternalSync: application.adminMode && category?.options?.externalSyncProvider,
    lastUpdated: knowledge.lastUpdated,
    lang: lang.KNOWLEDGE_BUTTONS,
    langTypes: lang.SEARCH_TYPES,
    langInfo: lang.INFORMATION_MODAL,
  };
};

const mapDispatchToProps = {
  knowledgeSelectItem,
  updateKnowledgeItemsOrder,
};

const ConnectedKnowledgeBinder = connect(
  mapStateToProps,
  mapDispatchToProps,
)(KnowledgeBinderComponent);

/**
 * The binder drawer for the `knowledge` query param: the category comes from the
 * store, its item rows are fetched by binder id.
 *
 * @returns {JSX.Element}
 * @example
 * <KnowledgeBinder />
 */
export const KnowledgeBinder = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const id = searchParams.get(INTERNAL_ROUTING.QUERY_PARAMS.KNOWLEDGE);
  const { data: knowledgeItems = [], isPending, isError, refetch } = useCategoryItems(id);

  return (
    <ConnectedKnowledgeBinder
      id={id}
      knowledgeItems={knowledgeItems}
      loading={!!id && isPending}
      loadError={isError}
      onRetry={refetch}
    />
  );
};
